export default __webpack_public_path__ + "static/media/12.b436ef0d.jpg";